export default function (el, bindings) {
  if (!bindings.value) {
    el.style.opacity = 0
    el.style.pointerEvents = 'none'

    return
  }

  el.style.opacity = 1
  el.style.pointerEvents = 'auto'
}
